module.exports = __webpack_public_path__ + "img/snorkeling-6.78c14adc.jpeg";